import Modal from "./Modal";
import { FaCheckCircle } from "react-icons/fa";

const SuccessModal = ({ 
  isOpen, 
  onClose, 
  title = "Success!", 
  message,
  buttonText = "Close",
  onButtonClick
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      icon={<FaCheckCircle />}
      type="success"
    >
      <div className="space-y-4">
        <p className="text-gray-700">
          {message || "Your action was completed successfully!"}
        </p>
        
        <div className="flex justify-end pt-4">
          <button
            onClick={onButtonClick || onClose}
            className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
          >
            {buttonText}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default SuccessModal;